export function formatCount(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

export function formatKpiValue(value, { integer = false } = {}) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const abs = Math.abs(n);
  const neg = n < 0 || Object.is(n, -0);
  const sign = neg ? '-' : '';
  if (abs >= 1_000_000) {
    return `${sign}${(abs / 1_000_000).toFixed(2)}M`;
  }
  if (abs >= 10_000) {
    return `${sign}${(abs / 1_000).toFixed(2)}K`;
  }
  return integer ? formatCount(n) : formatMoney(n);
}

export function formatCompact(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  if (Object.is(n, -0) || n < 0) {
    const abs = Math.abs(n);
    if (abs >= 1_000_000) return `-${(abs / 1_000_000).toFixed(2)}M`;
    if (abs >= 1_000) return `-${(abs / 1_000).toFixed(2)}K`;
    return `-${abs.toFixed(2)}`;
  }
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(2)}K`;
  return n.toFixed(2);
}

export function formatMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const formatted = Math.abs(n).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return n < 0 || Object.is(n, -0) ? `-${formatted}` : formatted;
}

export function isNegativeNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) && (n < 0 || Object.is(n, -0));
}

/** Flip sign for display (negative → positive, positive → negative). */
export function mirrorSign(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return value;
  return -n;
}

export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}
